import React, { useContext, useState } from "react";
import { Wrapper, Container, Div, AnimText, activeRowStyle } from "./style";
import { Icon } from "semantic-ui-react";
import { Table } from "react-bootstrap";
import styled from "styled-components";
import Title2 from "../Commons/Title2";
import { ThemeContext } from "../../ThemedContext/Provider";

const src = "../../../assets/indescribable.mp3";
const src1 = "../../../assets/music1.mp3";
let audio = new Audio();

var musicData = [
  {
    id: '0920',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '093',
    title: 'Shown',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '0910',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '0910',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '0910',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '0910',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '0910',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '0910',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
  {
    id: '0910',
    title: 'Falling into you',
    album: 'Sweet Rose',
    duration: '02 : 00',
    isFav: true,
    isPlaying: false
  },
]

musicData = [...musicData, ...musicData, ...musicData]

musicData = musicData.map((music, i) => ({ ...music, src: i % 2 ? src : src1 }))

const Trending = () => {
  const [musics, setMusic] = useState(musicData);
  const [isPlaying, setIsPlaying] = useState(false)
  const [duration, setDuration] = useState('00:00')
  const [currentPlayTitle, setCurrentPlayTitle] = useState('')

  const { theme } = useContext(ThemeContext);

  function favoriteHandler(ind) {
    let _musics = musics;

    if (_musics[ind]) {
      _musics[ind].isFav = !_musics[ind]?.isFav

      setMusic([..._musics])
    }
  }

  function continuePlay(music, ind) {
    let _musics = musics;

    if (audio.paused) {
      audio.play()
      _musics[ind].isPlaying = true;

      setCurrentPlayTitle(music.title)
      setMusic([..._musics])
      setIsPlaying(true)
    }
  }

  function playHandler(music, ind) {
    let _musics = musics;

    _musics = _musics.map(music => ({ ...music, isPlaying: false }))

    audio.src = _musics[ind].src;

    audio.play();
    audio.ontimeupdate = (event) => {
      setDuration(mmss(audio.currentTime));
    }

    _musics[ind].isPlaying = true;

    setCurrentPlayTitle(music.title)
    setMusic([..._musics])
    setIsPlaying(true)
  }

  function stopHandler(music, ind) {
    let _musics = musics;

    audio.pause();
    audio.currentTime = 0;
    _musics[ind].isPlaying = false;
    audio.ontimeupdate = null;

    setMusic([..._musics])
    setIsPlaying(false)
  }

  function pauseHandler() {
    if (!audio.paused) {
      audio.pause();
      setIsPlaying(false)
    }
  }

  function renderDetails(music, indx) {
    return (
      <tr class="tableRow">
        <td>
          <IconsHolder>
            <span>{indx + 1}</span>
            <span onClick={() => favoriteHandler(indx)}>
              {music?.isFav
                ? <Icon className='favorite' name='star' />
                : <Icon className='favorite' name='star outline' />
              }
            </span>
            <span onClick={() => playHandler(music, indx)} className='musicBtn'>
              {!music?.isPlaying ? <Icon className='playBtn' name='play' /> : <></>}
            </span>

          </IconsHolder>
        </td>
        <td>{music.isPlaying ? currentPlayTitle : music?.title}</td>
        <td>{music?.album}</td>
        <td>{music.isPlaying ? duration : music?.duration}</td>
        <td>
          <IconsHolder>
            <Icon name='download' className='icon' />
            <Icon name='list' className='icon' />
          </IconsHolder>
        </td>
      </tr>
    )
  }

  function renderControls(music, indx) {
    return (
      <tr class="tableRow" style={activeRowStyle(music?.isPlaying, theme)}>
        <td>
          <IconsHolder>
            <span>{indx + 1}</span>
            {
              isPlaying
                ? <Icon name='play' onClick={() => continuePlay(music, indx)} />
                : <Icon name='pause' onClick={() => pauseHandler()} />
            }
            <Icon onClick={() => stopHandler(music, indx)} className='musicBtn' name='stop' />
          </IconsHolder>
        </td>
        <td style={{ position: 'relative', overflow: "hidden" }}>
          <AnimText>{music?.title}</AnimText>
        </td>
        <td>{music?.album}</td>
        <td>
          <p> {music.isPlaying ? duration : music?.duration}</p>
        </td>
        <td>
          <div onClick={() => favoriteHandler(indx)}>
            {music?.isFav
              ? <Icon className='favorite' name='star' />
              : <Icon className='favorite' name='star outline' />
            }
          </div>
        </td>
      </tr>
    )
  }

  return (
    <Div>
      <Title2 title='TRENDING SONGS' />
      <Wrapper>
        <Container>
          <StyledTable themed={theme} hover responsive>
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Song</th>
                <th scope="col">Album</th>
                <th scope="col">Duration</th>
                <th scope="col">Options</th>
              </tr>
            </thead>
            <tbody>
              {
                musics.map((music, indx) => (
                  music.isPlaying ? renderControls(music, indx) : renderDetails(music, indx)
                ))
              }
            </tbody>
          </StyledTable>
        </Container>
        <ShowMoreHolder>
          <span>SHOW MORE</span> <Icon name='arrow down'></Icon>
        </ShowMoreHolder>
      </Wrapper>
    </Div>
  );
};

export default Trending;

function pad(num) {
  return ("0" + num).slice(-2);
}

function mmss(secs) {
  let _secs = '' + secs;
  let _sInt = parseInt(_secs.split('.')[0])
  _secs = _sInt % 60;

  let minutes = parseInt(_sInt / 60);
  return `${pad(minutes)} : ${pad(_secs)}`;
}

const StyledTable = styled(Table)`
  th, td {
    border-top: ${({ themed }) => (themed ? '1px solid #ffffff14 !important' : '')};
  }

  thead, tbody{
    color: ${({ themed }) => (themed ? "white" : "#04031D")};
  }
`

const ShowMoreHolder = styled.div`
  text-align: center;
  cursor: pointer;
  color: #f94e3f;
`

const IconsHolder = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    .play{
      width: 1em;
    }

    .icon {
      cursor: pointer;
    }

    .favorite, .play{
      color: #f94e3f;
      cursor: pointer;
    }

    .musicBtn {
      display: inline-block;
      width: 15px;
    }
`;